import React from 'react'
import {Box, Button, Modal, Typography} from '@mui/material'
import closeIcon from 'assets/images/cross-icon.svg'
import './index.scss'

interface CPSModalProps {
    isModalOpen?: boolean
    className?: string
    title?: string
    content?: any
    isClosable?: boolean
    maxWidth?: string
    sx?: any
    handleModalClose?(...args: unknown[]): unknown
    titleStyles?: string
}

const CPSModal = ({
    isModalOpen,
    className,
    content,
    title,
    isClosable,
    handleModalClose,
    maxWidth,
    sx,
    titleStyles
}: CPSModalProps) => (
    <Modal
        open={isModalOpen ?? false}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        className={`${className} cps-modal`}
        disableEscapeKeyDown
    >
        <Box
            className={`${className}-container cps-modal-container`}
            maxWidth={maxWidth}
            sx={sx ?? {backgroundColor: '#f6f9fc'}}
        >
            <Typography
                id='modal-modal-title'
                variant='h6'
                component='h2'
                className={titleStyles ?? 'titleStyles'}
            >
                {title}
                {isClosable && (
                    <Button onClick={handleModalClose} className='close-modal' type='button'>
                        <img src={closeIcon} className='close-modal-icon' alt='Close' />
                    </Button>
                )}
            </Typography>
            <Box className='cps-modal-content'>{content}</Box>
        </Box>
    </Modal>
)

CPSModal.defaultProps = {
    isModalOpen: false,
    className: '',
    title: '',
    content: null,
    isClosable: false,
    maxWidth: '450px',
    sx: {backgroundColor: '#f6f9fc'},
    handleModalClose: () => {},
    titleStyles: 'titleStyles'
}

export default CPSModal
